import React from 'react';
import { useNavigate } from 'react-router';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CommonButton from '../../component/button/Button';

const Success = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-column items-center justify-center h-screen">
      <CheckCircleOutlineIcon sx={{ fontSize: 80, color: 'green' }} />
      <h1>Payment Successful!</h1>
      <p>Thank you for subscribing. Your account is now active.</p>
      <CommonButton text="Go to Dashboard" onClick={() => navigate('/dashboard')} />
    </div>
  );
};
export default Success;